import { render } from "./NoResults.vue?vue&type=template&id=0d59ffd3"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"

import "./NoResults.vue?vue&type=style&index=0&id=0d59ffd3&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__